import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getMyProfile } from "../../Api/userapi";
import { formatDate } from "../../helperFunction/FormatDate";

function ProfilePage({profileData}) {
  return (
    <div class="col-span-8">
      <div class="my-10 flex max-w-xs flex-col items-center rounded-xl border px-4 py-4 text-center md:max-w-lg md:flex-row md:items-start md:text-left">
        <div class="mb-4 md:mr-6 md:mb-0">
          <img
            class="h-56 rounded-lg object-cover md:w-56"
            src="https://images.unsplash.com/flagged/photo-1570612861542-284f4c12e75f?ixlib=rb-1.2.1&amp;ixid=MnwxMjA3fDB8MHxzZWFyY2h8M3x8cGVyc29ufGVufDB8fDB8fA%3D%3D&amp;auto=format&amp;fit=crop&amp;w=500&amp;q=60"
            alt="profile photo"
          />
        </div>
        <div class="">
          <p class="text-xl font-medium text-gray-700">{profileData?.name}</p>
          <p class="mb-4 text-sm font-medium text-gray-500">
            {profileData?.email}
          </p>
          <div class="flex space-x-2">
            <div class="flex flex-col items-center rounded-xl bg-teal-100 px-4 py-2">
              <p class="text-sm font-medium text-gray-500">Blogs</p>
              <p class="text-3xl font-medium text-gray-600">
                {profileData?.blogCount}
              </p>
            </div>
            <div class="flex flex-col items-center rounded-xl bg-teal-100 px-4 py-2">
              <p class="text-sm font-medium text-gray-500">Followers</p>
              <p class="text-3xl font-medium text-gray-600">---</p>
            </div>
            <div class=""></div>
          </div>
          <div class="mb-3"></div>
          <div class="flex flex-col items-center rounded-xl bg-teal-100 px-4 py-2">
            <p class="text-sm  text-gray-500">Member Since</p>
            <p class="text-sm font-medium  text-gray-600">
              {formatDate(profileData?.createdAt)}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProfilePage;
